import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Services } from '..'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { FormsModule } from '@angular/forms'

@Component({
    templateUrl: './prompt-value.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
    imports: [FaIconComponent, FormsModule],
})
export class PromptValueComponent {
    faCircleQuestion = faCircleQuestion
    constructor(
        private _activeModal: NgbActiveModal,
        private services: Services,
    ) {}
    public inputLabel!: string
    public inputValueType!: string
    public title!: string
    public message!: string
    public promptValue

    public yes(): void {
        if (this.inputValueType === 'number') {
            if (this.promptValue === '' || this.promptValue <= 0) {
                this.services.notification.warning('Please enter a value greater than 0')
                return
            }
        }
        this._activeModal.close(this.promptValue)
    }
    public no(): void {
        this._activeModal.dismiss('cancel')
    }
}
